import {Component, OnInit} from '@angular/core';
import {RecentProjectsService} from './recent-projects.service';

import {Observable} from 'rxjs/Observable';
import {AnonymousSubscription} from 'rxjs/Subscription';

@Component({
  selector: 'sa-recent-projects',
  templateUrl: './recent-projects.component.html',
  providers: [RecentProjectsService]
})
export class RecentProjectsComponent implements OnInit {

  projects: Array<any>;
  user:any;
  email: string;
  fullName: string;
  message: any;
  private timerSubscription: AnonymousSubscription;

  constructor(private projectsService: RecentProjectsService) {

  }

  ngOnInit() {

    //this.projects = this.projectsService.getProjects()
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.user = currentUser;
    this.fullName = this.user.userSystem.fullName;
    this.email = currentUser.userSystem.email;
    this.refreshProjects();

    // debugger;
  }

  clearProjects(){
    this.projects = [];
    sessionStorage.setItem("listaRecientes", JSON.stringify(this.projects));
  }

  private refreshProjects(): void {
    let lista = sessionStorage.getItem("listaRecientes");
    this.projects = JSON.parse(lista);
    this.subscribeToProjects();
  }

  private subscribeToProjects(): void {
    this.timerSubscription = Observable.timer(1000).first().subscribe(() => this.refreshProjects());
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/recent-projects/recent-projects.component.ts